/* USP Icons Bar (sections/usps-bar-icons.liquid)
   Mobile-only slick carousel. We init/destroy via matchMedia rather than
   slick's `responsive: 'unslick'` because that unslick is irreversible —
   once slick destroys itself at desktop it never re-inits on resize back
   down. matchMedia re-syncs on every breakpoint crossing (incl. the
   customizer device toggle, which resizes rather than reloads). */

(function () {
  var MOBILE = window.matchMedia('(max-width: 767px)');

  var OPTS = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: false
  };

  function sync(bar) {
    if (!window.jQuery || !jQuery.fn.slick) return;
    var $track = jQuery(bar).find('[data-usp-track]');
    var isSlick = $track.hasClass('slick-initialized');
    if (MOBILE.matches && !isSlick) {
      $track.slick(OPTS);
    } else if (!MOBILE.matches && isSlick) {
      $track.slick('unslick');
    }
  }

  function syncAll(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-usp-bar]'), sync);
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    syncAll(document);
    if (MOBILE.addEventListener) {
      MOBILE.addEventListener('change', function () { syncAll(document); });
    } else if (MOBILE.addListener) {
      MOBILE.addListener(function () { syncAll(document); });
    }
  });

  document.addEventListener('shopify:section:load', function (e) { syncAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var track = e.target.querySelector('[data-usp-track]');
    if (track && window.jQuery && jQuery(track).hasClass('slick-initialized')) {
      jQuery(track).slick('unslick');
    }
  });
})();
